'use client';
import { ComposerIncognitoHint } from '#pplx/frontend/apps/ask/composer-sdk-plugins/footer-controls/ComposerIncognitoHint.js';
import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { useMemo } from 'react';
const incognitoHintPlugin = createPlugin({
    id: 'thread-composer-incognito-hint',
    capabilities: [
        {
            kind: 'slot',
            components: [{ slot: 'leftAttribution', component: ComposerIncognitoHint }],
        },
    ],
});
function RightAttribution({ content }) {
    return content;
}
/** Preserves list order and stable slot identities when footer content changes. */
function createRightAttributionPlugins(attributions) {
    const plugins = {
        beforeModelControls: [],
        afterModelControls: [],
    };
    for (const { id, content, placement } of attributions) {
        if (content === null || content === undefined)
            continue;
        const createAttributionPlugin = createPluginFactory({
            name: id,
            capabilities: [
                {
                    kind: 'slot',
                    components: [{ slot: 'rightAttribution', component: RightAttribution }],
                },
            ],
        });
        plugins[placement].push(createAttributionPlugin({ content }));
    }
    return {
        beforeModelControls: Object.freeze(plugins.beforeModelControls),
        afterModelControls: Object.freeze(plugins.afterModelControls),
    };
}
/** Places supplied controls around the model selector and reuses the shared incognito hint. */
export function useAskComposerFooterControls({ beforeModelControls, afterModelControls, showIncognitoHint = false, }) {
    return useMemo(() => {
        const plugins = createRightAttributionPlugins([
            {
                id: 'thread-composer-leading-right-attribution',
                content: beforeModelControls,
                placement: 'beforeModelControls',
            },
            {
                id: 'thread-composer-additional-right-attribution',
                content: afterModelControls,
                placement: 'afterModelControls',
            },
        ]);
        return {
            ...plugins,
            beforeModelControls: Object.freeze([
                ...(showIncognitoHint ? [incognitoHintPlugin] : []),
                ...plugins.beforeModelControls,
            ]),
        };
    }, [afterModelControls, beforeModelControls, showIncognitoHint]);
}
//# sourceMappingURL=useAskComposerFooterControls.js.map